import { render, staticRenderFns } from "./BuyBoxOfferNew.vue?vue&type=template&id=07007194&scoped=true"
import script from "./BuyBoxOfferNew.vue?vue&type=script&setup=true&lang=ts"
export * from "./BuyBoxOfferNew.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BuyBoxOfferNew.vue?vue&type=style&index=0&id=07007194&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07007194",
  null
  
)

export default component.exports